<template>
    <v-modal-slot id="change-expedient-responsible-modal"
                  @accepted="emitResponsibleChanged">
        <template v-slot:modal-title>
            Responsable
        </template>

        <template v-slot:modal-content>
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label class="form-label">Responsable: </label>
                        <select class="form-select" aria-label="Responsable" v-model="selected_responsible">
                            <option :value="responsible.key" :key="responsible.id" v-for="responsible in responsibleOptions">
                                {{ responsible.value }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </template>

        <template v-slot:accept-button>
            Guardar
        </template>

        <template v-slot:close-button>
            Cerrar
        </template>
    </v-modal-slot>
</template>

<script>
import {getResponsibles} from "../../../../helpers/requests/RequestsExpedients";
import VModal from "../../../general/VModal";
import VModalSlot from "../../../general/VModalSlot";

export default {
    name: "ExpedientDetailChangeResponsibleModal",
    components: {VModalSlot, VModal},
    data() {
        return {
            selected_responsible: '',
            responsibleOptions: [],
        }
    },
    props: {
        responsible: {
            type: String,
            required: false,
        }
    },
    async mounted() {
        await this.loadResponsibles();

        this.selected_responsible = this.responsible;
    },
    methods: {
        async loadResponsibles() {
            this.responsibleOptions = await getResponsibles();
        },
        emitResponsibleChanged() {
            this.$emit('responsible-changed', this.selected_responsible);
        }
    },
}
</script>
